import React from "react";
import { useSelector } from "react-redux";
import { MailingAddressPreview } from "@qgiv/core-donor";
import { selectRegistrationsFromRegistration } from "../../redux/slices/registrationSlice";
import { selectHasParentRegistration } from "../../redux/slices/appSettingsSlice";
import { selectParentRegistration } from "../../redux/slices/parentRegistrationSlice";

const ConnectedMailingAddressPreview = () => {
    const registrations = useSelector(selectRegistrationsFromRegistration);
    const hasParentRegistration = useSelector(selectHasParentRegistration);
    const parentRegistration = useSelector(selectParentRegistration);

    const {
        Address_1 = "",
        Address_2 = "",
        City = "",
        State = "",
        Zip = "",
        Country = "",
    } = hasParentRegistration ? parentRegistration : registrations[0];

    const mailingAddressPreviewProps = {
        Address: Address_1,
        Address_2,
        City,
        State,
        Zip,
        Country,
    };

    return <MailingAddressPreview {...mailingAddressPreviewProps} />;
};

export default ConnectedMailingAddressPreview;
